// see src/web/theme/modules/StorefrontContent/sources/index.js
export default [];
